<template>
	<div class="main" >
		<common-header :keyword="search_keyword" @confirm="searchConfirm"></common-header>
		<div class="container text-left">
			<div class="keyword">
				当前搜索："
				<span class="search_param">{{ search_keyword }}</span>
				"，共为您找到
				<span class="search_param">{{ total }}</span>
				件相关商品
			</div>
			<div class="cate border">
				您是不是想找：
				<span class="cate-li" v-for="(cate, index) in categoryList" :key="index" @click="toList(cate.name)">{{ cate.name }}</span>
			</div>
			<div>
				<el-button-group class="filter">
					<el-button type="default" icon="el-icon-edit" :class="{active:filterIndex==0}" @click="filterChange(0)">综合排序</el-button>
					<el-button type="default" icon="el-icon-share" :class="{active:filterIndex==1}" @click="filterChange(1)">销量优先</el-button>
					<el-dropdown @command="filterCommand" :class="{active:filterIndex==2}">
						<el-button type="default">
							价格排序
							<i class="el-icon--right" :class="priceOrder==1?'el-icon-upload2':'el-icon-download'"></i>
						</el-button>
						<el-dropdown-menu slot="dropdown">
							<el-dropdown-item :command="1">价格从低到高</el-dropdown-item>
							<el-dropdown-item :command="2">价格从高到低</el-dropdown-item>
						</el-dropdown-menu>
					</el-dropdown>
				</el-button-group>
			</div>
			<div class="guess" v-if="goodsList.length" >
				<div class="goods-item" style="border: 0;">
					<div class="section" style="width: 100%;margin: 0;padding: 0;">
						<div class="section-item"  v-for="(item, index) in goodsList" :key="index" @click="toDetail(item.id)">
							<div class="goods-pic"><img :src="getWebPic(item.smpic)" alt="" :title="item.name" /></div>
							<p class="goods-title" :title="item.name">{{ item.name }}</p>
							<p class="flex">
								<span class="goods-price">￥{{ item.price }}</span>
								<span class="goods-sale">销量 {{ item.sales }}</span>
							</p>
							
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="block">
			<el-pagination
				@size-change="handleSizeChange"
				@current-change="handleCurrentChange"
				:current-page="thispage"
				:page-sizes="pageSizes"
				:page-size="pagesize"
				layout="total, sizes, prev, pager, next, jumper"
				:total="total"
			></el-pagination>
		</div>
	</div>
</template>

<script>
import { mapActions } from 'vuex';
import commonHeader from '../../components/common/commonHeader.vue';
export default {
	name: 'goodsList',
	components: {
		commonHeader
	},
	data() {
		return {
			search_keyword: '',
			cateId: '',
			cateLevel: '',
			categoryList: [],
			goodsList: [],
			thispage: 1,
			total: 0,
			pagesize: 30, //每页显示条数
			pageSizes: [30] ,//每页显示个数选择器
			filterList: ['', 'sales', 'price'],
			filterIndex: 0, //筛选条件
			priceOrder: 1, //1 价格从低到高 2价格从高到低
		};
	},
	watch: {
		$route(to, from) {
			//监听路由参数变化
			if (this.$route.query.search) {
				let query = this.$route.query;
				console.log(query);
				this.search_keyword = query.search;
				this.cateId = query.cateid ? query.cateid : '';
				this.cateLevel = query.level ? query.level : 1;
				this.getGoodsList('firstLoad');
			}
		}
	},
	mounted() {
		let query = this.$route.query;
		this.search_keyword = query.search;
		this.cateId = query.cateid ? query.cateid : '';
		this.cateLevel = query.level ? query.level : 1;
		
		this.getGoodsList('firstLoad');
	},
	methods: {
		...mapActions({
			exit: 'auth/logout'
		}),
		getGoodsList(firstLoad = false) {
			this.$emit('showLoading',true);
			this.loading = true;
			this.$request
				.post('/home.goods/goodsListWeb', {
					thispage: this.thispage,
					pagesize: this.pagesize,
					name: this.search_keyword,
					category: this.cateId,
					cateLevel: this.cateLevel,
					firstLoad: firstLoad,
					filter: this.filterList[this.filterIndex],
					priceorder: this.priceOrder,
				})
				.then(res => {
					console.log(res.data);
					this.$emit('showLoading',false);
					if (res.data.status == 0) {
						this.$message.error(res.data.msg);
						if (res.data.admin_err == 'userinfo_error') {
							this.exit().then(res => {
								console.log(res);
								if (res.actionStatus == 1) {
									this.$router.push('/login');
								}
							});
						}
					} else {
						this.goodsList = res.data.data;
						if(firstLoad){
							this.categoryList = res.data.category;
						}
						this.total = res.data.total;
					}
				})
				.catch(err => {
					console.log(err);
					this.$emit('showLoading',false);
				});
		},
		handleSizeChange(val) {
			console.log(`每页 ${val} 条`);
			this.pagesize = val;
			this.getGoodsList();
		},
		handleCurrentChange(val) {
			console.log(`当前页: ${val}`);
			this.thispage = val;
			this.getGoodsList();
		},
		searchList() {
			this.cateId = '';
			this.cateLevel = 1;
			this.getGoodsList('firstLoad');
		},
		searchConfirm(e) {
			console.log('search', e);
		},
		toList(keyword) {
			this.$router.push({ path: '/goods', query: { search: keyword } });
		},
		filterChange(filterIndex){
			this.filterIndex = filterIndex;
			this.thispage = 1;
			this.getGoodsList();
		},
		filterCommand(e){
			this.filterIndex = 2;
			this.priceOrder = e;
			this.thispage = 1;
			this.getGoodsList();
		}
	}
};
</script>

<style lang="scss">
@media screen and (max-width: 768px) {
	.el-message-box {
		width: 350px;
	}
}
.search_param {
	margin: 0 7px;
	color: red;
}
.cate {
	line-height: 40px;
	padding: 0 15px;
	margin: 15px 0;
	.cate-li {
		padding: 0 15px;
		cursor: pointer;
		&:hover {
			color: red;
		}
	}
}
.filter{
	margin-bottom: 15px;
	.el-button{
		&:hover{
			color:red
		}
		&.active{
			color:red;
			background-color: #ffe9dc;
		}
	}
	.el-dropdown{
		margin: 0 1px;
		&.active{
			.el-button{
				color:red;
				background-color: #ffe9dc;
			}
		}
	}
}
</style>
